import template from './help.html';
import controller from './help.controller';

let helpComponent = {
    template: template,
    controller: controller,
    controllerAs: 'helpCtrl'
  };

export default helpComponent;
